import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
import { IUpdateProps } from '~/interfaces/IUpdateProps';
import IMaterialGroup from '../interfaces/IMaterialGroup';

export async function getMaterialGroupById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/material-group/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function getMaterialGroups({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  name,
}: IParamsTable & { readonly name?: string } = {}) {
  const response = await authFetch({
    url: '/material-group',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      name,
    },
  });
  return response.data;
}

export async function getAllMaterialGroups(): Promise<readonly IMaterialGroup[]> {
  const response = await authFetch({
    url: '/material-group',
    method: 'GET',
  });
  return response.data;
}